function slugify(text) {
  return text
    .toString()
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function categoryPrefix(categoryName) {
  if (!categoryName) return '';
  return categoryName
    .split(/\s+/)
    .filter(Boolean)
    .map(w => w[0].toUpperCase())
    .join('');
}

export function generateParentCode(categoryName, productName) {
  const prefix = categoryPrefix(categoryName);
  if (!prefix) return '';
  const slug = slugify(productName);
  return `${prefix}-${slug}`;
}

export function generateVariantSku(parentCode, weightValue, weightUnit) {
  if (!parentCode) return '';
  const weight = Number(weightValue);
  if (!isFinite(weight)) return parentCode;
  const unit = (weightUnit || '').toUpperCase();
  const weightPart = unit ? `${weight}${unit}` : slugify(String(weight));
  return `${parentCode}-${weightPart}`;
}

export function getWeightUnitOptions() {
  return ['g', 'kg', 'ml', 'L'].map(u => ({ value: u, label: u }));
}
